<template>
    <v-footer color="primary" dark>
      <v-container>
        <v-row>
          <v-col cols="12" md="4" class="text-center">
            <h3 class="title">AT Innovations Solutions</h3>
            <p>Innovación y tecnología a tu alcance</p>
          </v-col>
          <v-col cols="12" md="4" class="text-center">
            <h3 class="title">Enlaces</h3>
            <v-btn text to="/aviso-de-privacidad">Aviso de Privacidad</v-btn>
            <v-btn text to="/terminos-y-condiciones">Términos y Condiciones</v-btn>
          </v-col>
          <v-col cols="12" md="4" class="text-center">
            <h3 class="title">Redes Sociales</h3>
            <v-btn icon href="#"><v-icon>mdi-facebook</v-icon></v-btn>
            <v-btn icon href="#"><v-icon>mdi-twitter</v-icon></v-btn>
            <v-btn icon href="#"><v-icon>mdi-linkedin</v-icon></v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
  </template>
  
  <script>
  export default {
    name: 'FooterSection',
  };
  </script>